/**
 * Canonical free-text input recipe — the "paper treatment" (DESIGN.md):
 * soft navy-tinted fill on radius 14 that turns to white paper on focus with
 * a quiet teal glow — never the browser's default focus blue. 16px type also
 * prevents iOS focus-zoom.
 *
 * Single source: every text/number input and textarea in the member surfaces
 * composes this string (FieldBlock fields, InlineProbeCapture). Restyling an
 * input somewhere else first means asking whether THIS recipe should change.
 */
export const PAPER_INPUT =
  'w-full rounded-[14px] border border-[rgba(26,35,50,0.10)] bg-[rgba(26,35,50,0.03)] px-5 py-4 font-body text-[16px] text-text-primary placeholder:text-text-tertiary transition-[border-color,background-color,box-shadow] duration-150 focus:border-accent focus:bg-bg-card focus:outline-none focus:shadow-[0_0_0_4px_rgba(45,139,139,0.10)]';
